<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import {queryCompanyList} from "../../../../api/home.js";
import config from "../../../../../configHttp.js";
import previewManuscript from "../../../common/requisitionDraft/previewManuscript/index.vue";

export default {
  components: {previewManuscript},
  data: function () {
    return {
      headData: getdata().headData,
      searchdiag: false,
      searchlist: getdata().searchlist,
      dateValue: "",
      searchdata: getdata().searchdata,
      tableData: [{id: 123, createTime: "2019-10-18", jzjtsuosq: "2019年09期", companyCode: "1100", companyName: "上海速元信息技术有限公司", generateStatus: "成功", sucCount: "4", failCount: "0"}],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0,
      companyNames: [],
      // 一键生成选择的公司
      companyName: "",
      jzjtsuosq: "",
      // 底稿预览
      previewManuscriptFlag: false,
      previewManuscriptId: -1,
    };
  },
  mounted() {
    this.loadHeadData()
  },
  created() {
    this.getDraftData();
  },
  methods: {
    loadHeadData() {
      // queryCompanyList().then(res => {
      //   if (res.data.code === 1) {
      //     let companyCodeVal = [];
      //     for (let i = 0; i < res.data.data.length; i++) {
      //       companyCodeVal.push({label: res.data.data[i].companyCode, value: res.data.data[i].companyCode})
      //     }
      //     this.searchlist[2].selectval = companyCodeVal;
      //     this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // });
    },
    getDraftData() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "createTime";
      params.order = "desc";
      // xxzzs_mxquery(params).then((res) => {
      //   this.pagination.total = res.data.data.total;
      //   this.pagination.paginationkey++;
      //   this.tableData = res.data.data.records;
      // });
    },
    generateInstantly() {
      this.$message.info("一键生成");
    },
    exportReport() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (selectVal.length > 0) {
        data.ids = selectVal.map((item) => item.id);
      } else {
        data.fapiaoInfoSearchExtendInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "oinv/details/export",
        typeObj: {
          toForm: false,
          fileName: "销项增值税票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl: this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getDraftData();
    },
    geOoverLength(e) {
      this.overlength = e;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getDraftData();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getDraftData();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getDraftData();
    },
    previewManuscript(row) {
      this.previewManuscriptId = row.id;
      this.previewManuscriptFlag = true;
    },
    previewManuscriptForback() {
      this.previewManuscriptFlag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
